var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"t",class:_vm.colorClass[_vm.colorIndex - 1]},[_c('span',[_vm._v(_vm._s(_vm.num > 9 ? '' : '0')+_vm._s(_vm.num))])])
}
var staticRenderFns = []

export { render, staticRenderFns }